module.exports = __webpack_public_path__ + "static/media/img_girl_reading_side.d6ac5cdf.png";